import { css, keyframes } from '@emotion/react'

export const MarkdownStyle = css`
  ul,
  ol {
    padding-left: 2em;
    padding-bottom: 0.6em;
    padding-top: 0.2em;
  }

  li {
    list-style-type: disc;
  }

  .inline-img {
    display: inline;
    padding: 0;
    vertical-align: baseline;
    height: 1em;
  }

  table {
    caption {
      color: #444;
      font-size: 0.9em;
      font-style: italic;
      text-align: left;
      padding: 0.2em 0.5em 0.5em 0;
    }
    th {
      background-color: #f4f4f4;
      font-weight: 600;
      text-align: center;
    }
    th,
    td {
      padding: 4px 8px;
      vertical-align: top;
      border: 1px solid #ddd;
      word-break: break-word;
    }
    border: 1px solid #ddd;
    border-radius: 8px;
    border-collapse: collapse;
    width: 100%;
    margin-bottom: 1em;
  }

  img[alt='clientLogo'] {
    background-color: black;
    width: 200px;
  }

  display: flex;
  flex-direction: column;
  gap: 8px;
`

const fadein = keyframes`
  from {
    opacity: 0;
    transform: translateX(10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

export const markdownContainer = css`
  animation: ${fadein} 0.5s ease-in-out both;
`
